module.exports = "<div class=\"cgp-loggedin-icon {badgeClass | inject}\"></div>";